import * as React from 'react';
import { ScrollIntoView } from '@grandvisionhq/common';
import { Alert } from '@grandvisionhq/iris-ui';

/** Helper component to render Alert message */ const ErrorAlert = ({ message  })=>{
    return /*#__PURE__*/ React.createElement(ScrollIntoView, {
        key: message
    }, /*#__PURE__*/ React.createElement(Alert, {
        variant: "error",
        className: "alert-m-default"
    }, message));
};

export { ErrorAlert };
//# sourceMappingURL=ErrorAlert.js.map
